import { JACKET_MENU, JACKET_SIDES } from '@/common/constants';

export default {
  namespaced: true,

  state: {
    activeNavPath: '',
    jacket: {
      price: 0,
      side: JACKET_SIDES.FRONT,
      menu: {
        [JACKET_SIDES.BACK]: [
          JACKET_MENU.JACKET,
          JACKET_MENU.COLLAR,
          JACKET_MENU.BODY,
          JACKET_MENU.SLEEVES,
          JACKET_MENU.TRIM,
        ],
        [JACKET_SIDES.FRONT]: [
          JACKET_MENU.JACKET,
          JACKET_MENU.COLLAR,
          JACKET_MENU.BODY,
          JACKET_MENU.SLEEVES,
          JACKET_MENU.POCKETS,
          JACKET_MENU.SNAPS,
          JACKET_MENU.TRIM,
        ],
        [JACKET_SIDES.LEFT]: [
          JACKET_MENU.JACKET,
          JACKET_MENU.COLLAR,
          JACKET_MENU.BODY,
          JACKET_MENU.SLEEVES,
          JACKET_MENU.POCKETS,
          JACKET_MENU.TRIM,
        ],
        [JACKET_SIDES.RIGHT]: [
          JACKET_MENU.JACKET,
          JACKET_MENU.COLLAR,
          JACKET_MENU.BODY,
          JACKET_MENU.SLEEVES,
          JACKET_MENU.POCKETS,
          JACKET_MENU.TRIM,
        ],
      },
      activeMenuItem: JACKET_MENU.JACKET,
    },
  },

  getters: {
    getJacketMenu: (state) => (jacketId) => state.jacket.menu[jacketId],

    getActiveMenuItem: (state) => state.jacket.activeMenuItem,

    getJacketSide: (state) => state.jacket.side,

    getActiveNavPath: (state) => state.activeNavPath,
  },

  mutations: {
    setActiveMenuItem (state, { page, menuItem }) {
      state[page].activeMenuItem = menuItem;
    },

    setJacketSide (state, side) {
      state.jacket.side = side;
    },

    setActiveNavPath (state, path) {
      state.activeNavPath = path;
    },
  },

  actions: {
    setActiveMenuItem ({ commit }, payload) {
      commit('setActiveMenuItem', payload);
    },

    setJacketSide ({ commit }, side) {
      commit('setJacketSide', side);
    }
  },
};
